export const TABS = [
  ["overview", "Overview"], ["alerts", "Alerts"], ["money", "Money"], ["operations", "Operations"], ["system", "System"], ["accounts", "Accounts"],
];

const DOT = { red: "bg-rose-500", amber: "bg-amber-400" };

// The tab bar: the URL hash picks the tab; a red dot = needs action, amber = warning.
export const DashTabs = ({ active, badges, onSelect }) => (
  <nav data-testid="dash-tabs" className="flex h-11 shrink-0 items-center gap-1 overflow-x-auto border-b border-border bg-background/90 px-3 lg:px-5">
    {TABS.map(([key, label]) => (
      <button
        key={key}
        type="button"
        data-testid={`dash-tab-${key}`}
        aria-current={active === key ? "page" : undefined}
        onClick={() => onSelect(key)}
        className={`relative flex items-center gap-2 rounded-full px-3.5 py-1.5 text-sm font-semibold transition-colors ${
          active === key ? "bg-foreground text-background" : "text-muted-foreground hover:bg-muted hover:text-foreground"}`}
      >
        {label}
        {badges?.[key] && (
          <span data-testid={`dash-badge-${key}`} data-tone={badges[key]} className={`h-2 w-2 rounded-full ring-2 ring-background ${DOT[badges[key]]}`} />
        )}
      </button>
    ))}
  </nav>
);
